import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';

import { useMedia } from '@/shared/hooks';

import { CompactCondition, conditionText } from '@/entities/condition';

import styles from './ConditionTitle.module.scss';

type ConditionTitleProps = {
  className?: string;
  conditionItem: CompactCondition;
  toothNumber: string;
  onHoverHandle: (conditionItem?: CompactCondition) => void;
  onClickHandle: () => void;
  isFMXToothChartMode?: boolean;
};

export const ConditionTitle: FC<ConditionTitleProps> = (props) => {
  const {
    className,
    conditionItem,
    onHoverHandle,
    onClickHandle,
    toothNumber,
    isFMXToothChartMode,
  } = props;

  const { formatMessage } = useIntl();
  const { isMobile } = useMedia();

  return (
    <div
      data-component="tooth-condition-title"
      className={cn(
        styles.container,
        styles[conditionItem?.color],
        isFMXToothChartMode && styles.chartModeTitleCondition,
        isMobile ? 'h2m' : 'h4',
        className,
      )}
      onMouseEnter={() => onHoverHandle(conditionItem)}
      onMouseLeave={() => onHoverHandle()}
      onClick={onClickHandle}
    >
      {conditionItem.code in conditionText &&
        formatMessage(conditionText[conditionItem.code])}{' '}
      {toothNumber}
    </div>
  );
};
